<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera tillgängliga enheter</h3>
  <br>
  <div class="sticky-header">
    <h3>Tillgängliga enheter</h3>
  </div>
  

  <form (ngSubmit)="updateDevices()">
    <app-woo-table [(data)]="devices" [debug]="false">
      <woo-table-column name="name" header="Namn"></woo-table-column>
      <woo-table-column name="active" header="Aktiv" >
        <ng-template let-cell>
          <toggle name="active-{{ cell.row.id }}" [(ngModel)]="cell.row.active" id="active-{{ cell.row.id }}"></toggle>
        </ng-template>
      </woo-table-column>
      <woo-table-column name="clickable" header="Klickbar">
        <ng-template let-cell>
          <toggle name="clickable-{{ cell.row.id }}" [(ngModel)]="cell.row.clickable" id="clickable-{{ cell.row.id }}"></toggle>
        </ng-template>
      </woo-table-column>
      <woo-table-column name="automated_guaranteed_enabled" header="AG">
        <ng-template let-cell>
          <toggle name="automated_guaranteed_enabled-{{ cell.row.id }}" [(ngModel)]="cell.row.automated_guaranteed_enabled" id="automated_guaranteed_enabled-{{ cell.row.id }}"></toggle>
        </ng-template>
      </woo-table-column>
      <woo-table-column name="pause_ad_enabled" header="Paus">
        <ng-template let-cell>
          <toggle name="pause_ad_enabled-{{ cell.row.id }}" [(ngModel)]="cell.row.pause_ad_enabled" id="pause_ad_enabled-{{ cell.row.id }}"></toggle>
        </ng-template>
      </woo-table-column>
    </app-woo-table>

    <button type="submit" class="button margin-top--3x">Spara</button>
  </form>
</div>